<template>
  <!-- Shared rounded search pill used across the networking pages so the
       search section looks identical everywhere. The inner input is made
       transparent/borderless (with a scoped !important override) so the
       global themed `input` rule in _variables.scss can't re-add a border. -->
  <div
    class="search-pill flex items-center gap-3 px-5 min-h-[44px] bg-slate-50 rounded-full border border-slate-200 focus-within:bg-white focus-within:border-slate-400 transition-all"
  >
    <i class="fal fa-search text-slate-400 shrink-0"></i>
    <input
      :value="value"
      type="text"
      :placeholder="placeholder"
      class="search-pill__input flex-1 min-w-0 bg-transparent border-0 p-0 text-sm text-slate-700 outline-none"
      @input="$emit('input', $event.target.value)"
    />
  </div>
</template>

<script>
export default {
  name: 'SearchPill',
  props: {
    value: { type: String, default: '' },
    placeholder: { type: String, default: '' }
  }
};
</script>

<style scoped>
.search-pill__input,
.search-pill__input:focus {
  background: transparent !important;
  border: 0 !important;
  outline: none !important;
  box-shadow: none !important;
}
</style>
